<template>
  <div class="skills-wrapper">
    <div class="__skills-wraper">
      <div class="__lined">
        <span class="labell section-title">Skills</span>
      </div>
      <div class="__content-body __bordered">
        <div class="__menus-tab">
          <div
            class="tab-item"
            @click="showSkillTab('isTab1')"
            :class="{ activetablink: tab3.isTab1 }"
          >
            <span>Tools</span>
          </div>

          <div
            class="tab-item"
            @click="showSkillTab('isTab2')"
            :class="{ activetablink: tab3.isTab2 }"
          >
            <span>Domains</span>
          </div>

          <div
            class="tab-item"
            @click="showSkillTab('isTab3')"
            :class="{ activetablink: tab3.isTab3 }"
          >
            <span>Competences</span>
          </div>

          <div
            class="tab-item"
            @click="showSkillTab('isTab4')"
            :class="{ activetablink: tab3.isTab4 }"
          >
            <span>Roles</span>
          </div>

          <div
            class="tab-item"
            @click="showSkillTab('isTab5')"
            :class="{ activetablink: tab3.isTab5 }"
          >
            <span>Languages</span>
          </div>
        </div>
        <div class="__tabs-body">
          <div class="__tabs__content" v-show="tab3.isTab1">
            <div class="tabs__content-wrapper">
              <div
                class="__headder"
                v-if="profile_data.skills_data.tools.length > 0"
              >
                <div class="icon-texts">
                  <span>All Tools</span>
                  <div class="__row"></div>
                </div>
              </div>

              <div class="skills-list">
                <!-- Tools list -->
                <div
                  v-if="profile_data.skills_data.tools.length > 0"
                  class="__containner"
                >
                  <div
                    v-for="(item, index) in profile_data.skills_data.tools"
                    :key="index"
                    class="item"
                  >
                    <div class="__roww" v-if="!item.editMode">
                      <span class="skill-name">{{ item.name | validate }}</span>
                      <star-rating
                        inactive-color="#C1C1C1"
                        :read-only="true"
                        active-color="#1BA5A4"
                        :star-size="15"
                        :show-rating="false"
                        v-model="item.priority"
                      ></star-rating>
                      <div class="__actions">
                        <span class="__colored __act" v-if="item.status"
                          >Active</span
                        >
                        <span class="span __colored __act" v-else>Passive</span>
                      </div>
                      <div class="__actionss"></div>
                    </div>
                  </div>
                </div>
                <!-- If tools not found -->
                <div v-else class="empty-skill">
                  <h1>No Tools Added yet</h1>
                </div>
              </div>
            </div>
          </div>
          <div class="__tabs__content" v-show="tab3.isTab2">
            <div class="tabs__content-wrapper">
              <div
                class="__headder"
                v-if="profile_data.skills_data.domains.length > 0"
              >
                <div class="icon-texts">
                  <span>Domains</span>
                  <div class="__row"></div>
                </div>
              </div>

              <div class="skills-list">
                <!-- Domain list -->
                <div
                  v-if="profile_data.skills_data.domains.length > 0"
                  class="__containner"
                >
                  <div
                    v-for="(item, index) in profile_data.skills_data.domains"
                    :key="index"
                    class="item"
                  >
                    <div class="__roww" v-if="!item.editMode">
                      <span class="skill-name">{{ item.name | validate }}</span>
                      <star-rating
                        inactive-color="#C1C1C1"
                        :read-only="true"
                        active-color="#1BA5A4"
                        :star-size="15"
                        :show-rating="false"
                        v-model="item.priority"
                      ></star-rating>
                      <div class="__actions">
                        <span class="__colored __act" v-if="item.status"
                          >Active</span
                        >
                        <span class="span __act" v-else>Passive</span>
                      </div>
                      <div class="__actionss"></div>
                    </div>
                  </div>
                </div>
                <!-- if no domain -->
                <div v-else class="empty-skill">
                  <h1>No Domains Added yet</h1>
                </div>
              </div>
            </div>
          </div>
          <div class="__tabs__content" v-show="tab3.isTab3">
            <div class="tabs__content-wrapper">
              <div
                class="__headder"
                v-if="profile_data.skills_data.competences.length > 0"
              >
                <div class="icon-texts">
                  <span>Competences</span>
                  <div class="__row"></div>
                </div>
              </div>

              <div class="skills-list">
                <!-- Compentence list -->
                <div
                  v-if="profile_data.skills_data.competences.length > 0"
                  class="__containner"
                >
                  <div
                    v-for="(item, index) in profile_data.skills_data
                      .competences"
                    :key="index"
                    class="item"
                  >
                    <div class="__roww" v-if="!item.editMode">
                      <span class="__colored">{{ item.name | validate }}</span>
                      <star-rating
                        inactive-color="#C1C1C1"
                        active-color="#1BA5A4"
                        :star-size="15"
                        :read-only="true"
                        :show-rating="false"
                        v-model="item.priority"
                      ></star-rating>
                      <div class="__actions">
                        <span class="__colored __act" v-if="item.status"
                          >Active</span
                        >
                        <span class="span __act" v-else>Passive</span>
                      </div>
                      <div class="__actionss"></div>
                    </div>
                  </div>
                </div>
                <!-- If compentences not fund -->
                <div v-else class="empty-skill">
                  <h1>No Compentence Added yet</h1>
                </div>
              </div>
            </div>
          </div>
          <div class="__tabs__content" v-show="tab3.isTab4">
            <div class="tabs__content-wrapper">
              <div
                class="__headder"
                v-if="profile_data.skills_data.roles.length > 0"
              >
                <div class="icon-texts">
                  <span>Roles</span>
                  <div class="__row"></div>
                </div>
              </div>

              <div class="skills-list">
                <!-- Role roles -->
                <div
                  v-if="profile_data.skills_data.roles.length > 0"
                  class="__containner"
                >
                  <div
                    v-for="(item, index) in profile_data.skills_data.roles"
                    :key="index"
                    class="item"
                  >
                    <div class="__roww" v-if="!item.editMode">
                      <span class="__colored">{{ item.name | validate }}</span>
                      <star-rating
                        inactive-color="#C1C1C1"
                        active-color="#1BA5A4"
                        :star-size="15"
                        :read-only="true"
                        :show-rating="false"
                        v-model="item.priority"
                      ></star-rating>
                      <div class="__actions">
                        <span class="__colored __act" v-if="item.searchable"
                          >Active</span
                        >
                        <span class="span __act" v-else>Passive</span>
                      </div>
                      <div class="__actionss"></div>
                    </div>
                  </div>
                </div>
                <!-- if roles is empty -->
                <div v-else class="empty-skill">
                  <h1>No Role Added yet</h1>
                </div>
              </div>
            </div>
          </div>
          <div class="__tabs__content" v-show="tab3.isTab5">
            <div class="tabs__content-wrapper">
              <div
                class="__headder"
                v-if="profile_data.skills_data.languages.length > 0"
              >
                <div class="icon-texts">
                  <span>Languages</span>
                  <div class="__row"></div>
                </div>
              </div>

              <div class="skills-list">
                <!-- List of languages -->
                <div
                  v-if="profile_data.skills_data.languages.length > 0"
                  class="__containner"
                >
                  <div
                    v-for="(item, index) in profile_data.skills_data.languages"
                    :key="index"
                    class="item"
                  >
                    <div class="__roww" v-if="!item.editMode">
                      <span class="__colored">{{ item.name | validate }}</span>

                      <star-rating
                        inactive-color="#C1C1C1"
                        :read-only="true"
                        active-color="#1BA5A4"
                        :star-size="15"
                        :show-rating="false"
                        v-model="item.level"
                      ></star-rating>

                      <div class="__actions">
                        <span class="__colored __act" v-if="item.status"
                          >Active</span
                        >
                        <span class="span __act" v-else>Passive</span>
                      </div>

                      <div class="__actionss"></div>
                    </div>
                  </div>
                </div>
                <!-- If no languages -->
                <div v-else class="empty-skill">
                  <h1>No Language Added yet</h1>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import dropdownMenu from "@/components/Partials/dropdownMenu";
import appDialog from "@/components/Dialog/AppDialog.vue";
import emptyTools from "@/components/Partials/emptyTools.vue";
import emptyDomains from "@/components/Partials/emptyDomains.vue";
import emptyCompetences from "@/components/Partials/emptyCompetences.vue";
import emptyRoles from "@/components/Partials/emptyRoles.vue";
import emptyLanguages from "@/components/Partials/emptyLanguages.vue";
import draggable from "vuedraggable";
import { mapGetters } from "vuex";
import HelpToolTip from "@/components/helper/HelpToolTip.vue";
import consultfiedButton from "@/components/helper/consultfiedButton.vue";
import { eventBus } from "@/main";
export default {
  name: "skills",
  components: {
    dropdownMenu,
    appDialog,
    draggable,
    emptyTools,
    emptyDomains,
    emptyCompetences,
    emptyRoles,
    emptyLanguages,
    HelpToolTip,
    consultfiedButton,
  },
  props: {
    id: {
      type: Number,
      default: null,
    },
  },
  data: () => {
    return {
      loading: false,
      tab3: {
        isTab1: true,
        isTab2: false,
        isTab3: false,
        isTab4: false,
        isTab5: false,
      },

      profile_data: {
        projects: [],
        skills_data: {
          tools: [],
          domains: [],
          languages: [],
          competences: [],
          roles: [],
        },
        skills: [],
        employment: [],
        educations: [],
        trainings: [],
        certifications: [],
        tags: [],
        notifications: [],
        user: {},
        profile: {},
      },
    };
  },
  mounted() {
    let vm = this;
    vm.getProfileData();
    vm.$store.dispatch("GET_COUNTRIES");
  },
  computed: {
    ...mapGetters(["getCountries", "getCities"]),
  },
  methods: {
    showSkillTab(key) {
      let vm = this;
      Object.keys(vm.tab3).forEach(function (key) {
        vm.tab3[key] = false;
      });
      this.tab3[key] = true;
    },
    getProfileData() {
      let vm = this;
      vm.$store
        .dispatch("GET_ME_PROFILE", { id: vm.$route.params.id })
        .then((response) => {
          let data = response.data;
          vm.profile_data = data;
          let skills = vm.processSkills(data.skills);
          eventBus.$set(vm.profile_data, "skills_data", skills);
        });
    },
    processSkills(skills_data) {
      let skills = {
        tools: [],
        domains: [],
        languages: [],
        competences: [],
        roles: [],
      };
      if (skills_data && skills_data.length > 0) {
        skills_data.forEach((skill) => {
          skill.tools.forEach((item) => {
            let obj = {
              id: item.id,
              name: item.name,
              priority: item.priority,
              editMode: false,
              type: "tools",
              order: item.order,
              status: item.status,
              searchable: item.status === 0 ? false : true,
              level: parseInt(item.priority),
            };
            skills.tools.push(obj);
          });
          skill.domains.forEach((item) => {
            let obj = {
              id: item.id,
              name: item.name,
              priority: item.priority,
              editMode: false,
              type: "domains",
              order: item.order,
              status: item.status,
              searchable: item.status === 0 ? false : true,
              level: parseInt(item.priority),
            };
            skills.domains.push(obj);
          });
          skill.competences.forEach((item) => {
            let obj = {
              id: item.id,
              name: item.name,
              priority: item.priority,
              editMode: false,
              type: "competences",
              order: item.order,
              status: item.status,
              searchable: item.status === 0 ? false : true,
              level: parseInt(item.priority),
            };
            skills.competences.push(obj);
          });
          skill.roles.forEach((item) => {
            let obj = {
              id: item.id,
              name: item.name,
              priority: item.priority,
              editMode: false,
              type: "roles",
              order: item.order,
              status: item.status,
              searchable: item.status === 0 ? false : true,
              level: parseInt(item.priority),
            };
            skills.roles.push(obj);
          });
          skill.languages.forEach((item) => {
            if (item.lang) {
              let obj = {
                id: item.id,
                name: item.lang.name,
                lang: item.lang.id,
                editMode: false,
                type: "languages",
                order: item.order,
                status: item.status,
                searchable: item.status === 0 ? false : true,
                level: parseInt(item.level),
              };
              skills.languages.push(obj);
            }
          });
        });
      }
      skills.tools.sort((start, end) => {
        return start.order - end.order;
      });
      skills.domains.sort((start, end) => {
        return start.order - end.order;
      });
      skills.languages.sort((start, end) => {
        return start.order - end.order;
      });
      skills.competences.sort((start, end) => {
        return start.order - end.order;
      });
      skills.roles.sort((start, end) => {
        return start.order - end.order;
      });
      return skills;
    },
  },
  watch: {},
};
</script>
<style lang="scss" scoped>
.skills-wrapper {
  width: 100%;
  .__skills-wraper {
    border-radius: 5px;
    width: 100%;
    background: #fff;
    padding: 20px;
    @media (min-width: 300px) and (max-width: 630px) {
      padding: 10px;
    }
    .__lined {
      margin-bottom: 10px;
      span {
        color: #1ba5a4;
        cursor: pointer;
      }
      .labell {
        font-size: 16px;
        font-weight: normal;
        color: #000000;
      }
      .section-title {
        @media (min-width: 300px) and (max-width: 630px) {
          font-weight: 800;
        }
      }
    }
    .__content-body {
      overflow: hidden;
      font-weight: normal;
      width: 100%;
      background: #f5f5f5;
      padding: 0px;
      h3 {
        margin-left: 40px;
        font-size: 17px;
        margin-top: 20px;
        color: #000000;
        margin-bottom: 20px;
        font-weight: normal;
      }
      .__menus-tab {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
        background: #c4c4c4 !important;
        border-top-left-radius: 5px;
        border-top-right-radius: 5px;
        margin: 0;
        @media (min-width: 300px) and (max-width: 630px) {
          margin: 0;
        }
        overflow: hidden;
        .tab-item {
          height: 47px;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: 500ms ease-in-out;
          @media (min-width: 300px) and (max-width: 630px) {
            height: 47px;
          }
          span {
            color: #f5f5f5;
            font-size: 15px;
            text-align: center;
            @media (min-width: 300px) and (max-width: 630px) {
              font-size: 10px;
            }
          }
        }

        .activetablink {
          background: #f5f5f5;
          font-weight: bold;
          display: flex;
          transition: 500ms ease-in-out;
          span {
            color: #1ba5a4;
            width: 100%;
            height: 100%;
            background: #fbfbfb2b;
            display: flex;
            align-items: center;
            justify-content: center;
          }
        }
      }
      .__tabs-body {
        position: relative;
        padding-left: 10px;
        padding-right: 10px;
        padding-bottom: 10px;
        @media (min-width: 300px) and (max-width: 630px) {
          padding: 10px 0;
        }
        .__tabs__content {
          position: relative;
          top: 0;
          left: 0;
          .tabs__content-wrapper {
            .__headder {
              display: flex;
              margin-top: 20px;
              flex-direction: column;
              .icon-texts {
                font-size: 17px;
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                color: #6e6e6e;
                padding-right: 31px;
                margin-bottom: 20px;
                align-items: center;
                padding-left: 51px;
                @media (min-width: 300px) and (max-width: 630px) {
                  font-size: 11px;
                  margin-bottom: 10px;
                  padding-left: 22px;
                }
                .__row {
                  display: flex;
                  flex-direction: row;
                  justify-content: space-between;
                  .add-skill-btn {
                    height: 35px;
                    border-radius: 5px;
                    color: #1890a9;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 14px;
                    white-space: nowrap;

                    img {
                      width: 15px;
                      margin-left: 5px;
                    }
                  }
                  .__item {
                    display: flex;
                    cursor: pointer;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    span {
                      margin-top: 10px;
                      font-size: 10px;
                    }
                    img {
                      width: 10px;
                      @media (min-width: 300px) and (max-width: 630px) {
                        width: 7px;
                      }
                    }
                  }
                }
              }
              label {
                font-size: 10px;
                color: #646262;
                font-weight: normal;
              }
            }
            .skills-list {
              padding-left: 50px;
              padding-right: 13px;
              @media (min-width: 300px) and (max-width: 630px) {
                padding-left: 20px;
              }
              .__containner {
                display: grid;
                grid-template-rows: 1fr;
                padding-right: 20px;
                @media (min-width: 300px) and (max-width: 630px) {
                  padding-right: 0;
                }
                .__roww {
                  border-radius: 5px;
                  display: grid;
                  grid-template-columns: 42% 67px 67px 50px;
                  margin-bottom: 8px;
                  cursor: grab;
                  background: #ffffff;
                  justify-content: space-between;
                  align-items: center;

                  padding: 12px 10px;
                  @media (min-width: 300px) and (max-width: 630px) {
                    grid-template-columns: 48% 53px 41px 40px;
                  }
                  .skill-name {
                    color: #837f7f;
                    min-width: 0;
                    text-overflow: ellipsis;
                    overflow: hidden;
                    white-space: nowrap;
                  }
                  span {
                    color: #837f7f;
                    min-width: 0;
                    text-overflow: ellipsis;
                    overflow: hidden;
                    white-space: nowrap;
                    @media (min-width: 300px) and (max-width: 630px) {
                      font-size: 10px !important;
                      margin-top: 3px;
                    }
                  }
                  .__actions {
                    display: flex;
                    min-width: 0;
                    justify-content: space-between;
                    span {
                      margin-left: 10px;
                      opacity: 0.4;
                    }
                    .__act {
                      opacity: 1;
                    }
                  }
                  .__actionss {
                    min-width: 0;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    img {
                      margin-right: 20px;
                      width: 15px;
                      height: 15px;
                      cursor: pointer;
                      @media (min-width: 300px) and (max-width: 630px) {
                        width: 10px;
                        height: 10px;
                        margin-right: 0;
                        margin-left: 5px;
                      }
                    }
                  }
                }
                .skill__edit {
                  display: flex;
                  flex-direction: column;
                  padding-left: 0px;
                  margin-bottom: 10px;
                  padding-top: 0px;
                  border-radius: 5px;
                  margin-bottom: 10px;
                  .__bg-white {
                    background: #fff;
                    padding: 7px 10px;
                    width: 60%;
                    border-radius: 5px;
                    margin-bottom: 10px;
                    margin-top: 5px;
                    outline: none;
                  }
                  .rating-skill {
                    background: #fdfdfd;
                    height: 40px;
                    border: 1px solid #ccc;
                    display: flex;
                    align-items: center;
                  }
                  .check {
                    width: 60%;
                    display: flex;
                    justify-content: space-between;
                    .help-tool-tip {
                      margin-top: 4px;
                    }
                    div {
                      display: flex;
                      margin-top: -5px;
                      input[type="checkbox"] {
                        background: #fff;
                        outline: none;
                        margin-left: 10px;
                        margin-top: 3px;
                        padding-left: 5px;
                        padding-right: 5px;
                        /*-webkit-appearance:button;*/
                        color: #fff;
                        white-space: nowrap;
                        overflow: hidden;
                        width: 15px;
                        height: 15px;
                        &:checked {
                          background-color: #000;
                        }
                      }
                    }
                    .label-check {
                      margin: -2px 5px 0 5px;
                    }
                  }
                  h5 {
                    font-size: 15px;
                    color: #6e6e6e;
                    margin-bottom: 20px;
                    font-weight: normal;
                  }
                  label {
                    color: #6e6e6e;
                    margin-bottom: 0;
                    font-size: 14px;
                    margin-left: 10px;
                    font-weight: normal;
                  }
                  .status {
                    margin-top: 10px;
                    font-size: 12px;
                  }
                  input[type="text"],
                  select {
                    background: #fdfdfd;
                    height: 40px;
                    border: 1px solid #ccc;
                    color: #000;
                    padding: 7px 10px;
                    width: 60%;
                    border-radius: 5px;
                    margin-bottom: 10px;
                    margin-top: 5px;
                    outline: none;
                  }
                  .actions-searchables {
                    display: flex;
                    margin-top: 10px;
                    justify-content: space-between;
                    .btns {
                      display: flex;
                      button {
                        outline: none;
                        border: none;
                        padding: 7px 20px;
                        border-radius: 5px;
                        margin-right: 10px;
                        font-size: 12px;
                        background: transparent;
                      }
                      .__c {
                        color: #1890a9;
                        padding: 7px 10px;
                        margin-left: 20px;
                        font-size: 14px;
                      }
                      .__s {
                        color: #fff;
                        background: #1890a9;
                        padding: 0px 20px;
                        font-size: 14px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        &:disabled {
                          background: #8d8d8d;
                          opacity: 0.3;
                        }
                      }
                    }
                  }
                }
              }
              .empty-skill {
                padding: 50px 0px;
                font-size: 13px;
              }
            }

            .skill__edit {
              display: flex;
              flex-direction: column;
              padding-left: 50px;
              border-radius: 5px;
              margin-bottom: 10px;
              padding-top: 27px;
              border-radius: 5px;
              margin-bottom: 10px;
              .help-section {
                display: flex;
                flex-direction: column;
                margin-bottom: 7px;
                label {
                  font-size: 15px;
                  margin-left: 0px;
                  margin-bottom: 10px;
                  font-style: italic;
                }
                span {
                  font-size: 12px;
                  font-weight: bold;
                }
              }
              .__bg-white {
                background: #fff;
                padding: 7px 10px;
                width: 60%;
                border-radius: 5px;
                margin-bottom: 10px;
                margin-top: 5px;
                outline: none;
              }
              .rating-skill {
                background: #fdfdfd;
                height: 40px;
                border: 1px solid #ccc;
                display: flex;
                align-items: center;
              }
              .check {
                width: 60%;
                display: flex;
                justify-content: space-between;
                .help-tool-tip {
                  margin-top: 4px;
                }
                div {
                  display: flex;
                  margin-top: -5px;
                  input[type="checkbox"] {
                    background: #fff;
                    outline: none;
                    margin-left: 10px;
                    margin-top: 3px;
                    padding-left: 5px;
                    padding-right: 5px;
                    /*-webkit-appearance:button;*/
                    color: #fff;
                    white-space: nowrap;
                    overflow: hidden;
                    width: 15px;
                    height: 15px;
                    &:checked {
                      background-color: #000;
                    }
                  }
                }
                .label-check {
                  margin: 2px 5px 0 5px !important;
                }
              }
              h5 {
                font-size: 15px;
                color: #000;
                margin-bottom: 20px;
                font-weight: normal;
              }
              label {
                color: #6e6e6e;
                margin-bottom: 0;
                font-size: 14px;
                margin-left: 10px;
                font-weight: normal;
              }
              .status {
                margin-top: 10px;
                font-size: 12px;
              }
              input[type="text"],
              select {
                background: #fdfdfd;
                height: 40px;
                border: 1px solid #ccc;
                color: #000;
                padding: 7px 10px;
                width: 60%;
                border-radius: 5px;
                margin-bottom: 10px;
                margin-top: 5px;
                outline: none;
              }
              .actions-searchables {
                display: flex;
                margin-top: 10px;
                .btns {
                  display: flex;
                  button {
                    outline: none;
                    border: none;
                    padding: 7px 20px;
                    border-radius: 5px;
                    margin-right: 10px;
                    font-size: 15px;
                    background: transparent;
                  }
                  .__c {
                    color: #1890a9;
                    font-size: 14px;
                    padding: 7px 10px;
                  }
                  .__s {
                    color: #fff;
                    background: #1890a9;
                    padding: 0px 45px;
                    font-size: 14px;

                    &:disabled {
                      background: #8d8d8d;
                      opacity: 0.3;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>